import { render, staticRenderFns } from "./UserLogs.vue?vue&type=template&id=1a701522&scoped=true&"
import script from "./UserLogs.vue?vue&type=script&lang=js&"
export * from "./UserLogs.vue?vue&type=script&lang=js&"
import style0 from "./UserLogs.vue?vue&type=style&index=0&id=1a701522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a701522",
  null
  
)

export default component.exports